import styles from "./InputError.module.scss";

interface IInputErrorProps {
  message?: string;
}

export const InputError = ({ message }: IInputErrorProps) => {
  return <div className={styles.error_message}>{message}</div>;
};
